// extracted by mini-css-extract-plugin
export default {"container":"style_container__vcrHA","icon":"style_icon__0mTRW","title":"style_title__-wY4I"};